import { formatUIDate } from 'utils/helpers'
import { ExternalArticlesReportPayloadItem } from '../interfaces'

export const toTableRowItems = (items: ExternalArticlesReportPayloadItem[]) =>
  items.map(item => ({
    id: item.id,
    reportNo: item.reportNo ?? '',
    legalEntity: item.legalEntity ?? '',
    storeName: item.storeName ?? '',
    sapId: item.sapId ?? '',
    storeType: item.storeType ?? '',
    date: formatUIDate(item.date),
    wasteCategoryName: item.wasteCategoryName ?? '',
    carrierName: item.carrierName ?? '',
    companyName: item.destination ?? '',
    measuredWeight: item.measuredWeight ?? ''
  }))
